import { Stack } from '@mui/material';

import { Typography, InfoOutlinedIcon, MetricTooltip } from '@occc/ui-design-system';

type EarningMechanismAwardSelectorProps = {
  isAwardVouchers: boolean;
  title: string;
};

export const EarningMechanismAwardSelectorTitle = ({
  isAwardVouchers,
  title,
}: EarningMechanismAwardSelectorProps) => {
  if (isAwardVouchers) {
    return (
      <Stack direction='row' alignItems='center' spacing={1} mb={2}>
        <Typography variant='subtitle1'>{title}</Typography>
        <MetricTooltip title='Award must be published to be selected'>
          <InfoOutlinedIcon fontSize='small' sx={{ color: 'silver' }} />
        </MetricTooltip>
      </Stack>
    );
  }

  return (
    <Typography variant='subtitle1' paragraph>
      {title}
    </Typography>
  );
};
